export default __webpack_public_path__ + "static/bagpuss-891ec6b102ae62f609677ad5b5c385d1.mp4";